module.exports = __webpack_public_path__ + "img/perforaciones_4-3.5c12947a.jpg";